import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { classnames } from 'tailwindcss-classnames';
import TimelineItem, { TimelineItemProps } from 'components/helpers/TimelineItem/TimelineItem';
import RichTextA11yWrapper from 'components/helpers/RichTextA11yWrapper';
import Button from 'components/helpers/Button';

export type TimelineProps = Sitecore.Override.ComponentBase &
  Components.General.Timeline.Fields.Timeline & {
    fields: {
      timelineItems: TimelineItemProps[];
    };
  };

const Timeline = ({ fields }: TimelineProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }

  const timelineItems = fields.timelineItems.map((item) => {
    return {
      ...item,
    } as TimelineItemProps;
  });

  const alignment = fields.timelineAlignment.value.toLowerCase();

  const isButtonPresent = !!fields.cta1?.value.href;
  const ctaClasses = classnames('w-full', 'sm:w-auto', 'text-center', 'md:text-left');

  const centerAlignedClass = classnames({
    'md:text-center': alignment === 'center',
  });

  return (
    <div data-component="authorable/general/timeline">
      <div className={classnames('timeline', 'py-6', centerAlignedClass)}>
        <h2 className={classnames('text-theme-heading-text', 'heading-lg', 'mb-2')}>
          {fields?.headingText?.value}
        </h2>
        <RichTextA11yWrapper
          className={classnames('mt-3', 'rte')}
          field={fields?.descriptionText}
          editable
        />
        <ul className={classnames('my-4', 'md:m-4')}>
          {timelineItems.map((timelineItem, i) => {
            return (
              <TimelineItem
                key={timelineItem.id}
                {...timelineItem}
                index={i}
                total={timelineItems.length}
                alignment={alignment}
              />
            );
          })}
        </ul>
        {isButtonPresent && (
          <Button linkField={fields.cta1} className={classnames('mt-2', ctaClasses)} />
        )}
      </div>
    </div>
  );
};

export default Timeline;
